module.exports = __webpack_public_path__ + "83dcdec06d9d5cc9e05b48673b90f552.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/Ruchika.png
// module id = 575
// module chunks = 30